import PromoCode from "../bundles/orders/utils/promoCode";

export default {
  /**
   * Search for a promo code. If found, a PromoCode object is returned.
   * @param {String} promoCodeText
   * @param {Object[]} lineItems - The line items included in the order.
   * @param {String} purchaseFlow - Ex. SHAPA_END_USER, CLEARSTEP_CLINICIAN.
   * @param {String} [referralCode] - Must be specified if attempting to apply the promo for using a referral code.
   * @returns {Promise<?PromoCode>}
   */
  search(promoCodeText, lineItems, purchaseFlow, referralCode) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/promo_codes/search",
        type: "GET",
        data: {
          promo_code_text: promoCodeText,
          line_items: lineItems,
          purchase_flow: purchaseFlow,
          referral_code: referralCode
        },
        success: response => resolve(new PromoCode(response.promo_type, response.promo_target, Number(response.amount), promoCodeText, response.applied_message, response.has_license_key)),
        error: response => {
          const errorMessage = response && response.responseJSON && response.responseJSON.error_message ? response.responseJSON.error_message : "There was an error applying your promo code. Please contact the Shapa customer support team.";
          reject(errorMessage);
        }
      });
    });
  }
}